import { useImmer } from 'use-immer';
import { IInlineBranchNode } from './types';
import { useCallback } from 'react';

const useInlineBranchState = () => {
  const [toggleState, setToggleState] = useImmer<Record<string, boolean>>({});

  const toggleInlineBranch = useCallback(
    (node: IInlineBranchNode) => {
      setToggleState((draft) => {
        draft[node.key] = !draft[node.key];
      });
    },
    [setToggleState],
  );

  const getIsExpandedInlineBranch = useCallback(
    (node: IInlineBranchNode) => {
      return toggleState[node.key] ?? false;
    },
    [toggleState],
  );

  return {
    toggleInlineBranch,
    getIsExpandedInlineBranch,
  };
};

export default useInlineBranchState;
